import { Transformer } from "../../../../Transformer/index.js";
import Api from "../../../../Api/AddressProgramArchived/ChannelApi";
import store from "../../../../Frontends/Common/store";

export class ChannelService {
  constructor() {
    this.transformer = new Transformer();
    this.Api = new Api();
  }
  async setPart(fields) {
    return await this.transformer.setFormPart(this.Api, "editChannel", fields);
  }
  async set() {
    return await this.transformer.setForm(this.Api, "editChannel");
  }
  async grid(args) {
    return await this.transformer.getGrid(this.Api, "getChannels", args);
  }
  async get(id) {
    return await this.transformer.getGridPanel(this.Api, "getChannel", null, id);
  }
  async create(model) {
    return await this.transformer.createItem(this.Api, "createChannel", model);
  }
  async delete(model) {
    return await this.transformer.deleteItem(this.Api, "deleteChannel", model);
  }
  async update(model) {
    return await this.transformer.editItem(this.Api, "editChannel", model);
  }
  async import(gfid) {
    const res = this.Api.import(gfid);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
  async getImportScaffold() {
    return await this.Api.getImportScaffold();
  }
  async export(filter, format) {
    const res = this.Api.export(filter, format);
    await store.dispatch('notifications/handleResponse', {
      promiseResponse: res,
    })
    return res;
  }
}
